import { IFullPlanDetailPPO } from "../../../interfaces/api";

import PPODoubleInfoBenefit from "./PPODoubleInfoBenefit.component";
import {
  getDoubleDataPPO,
  getDoubleDeepPPO,
} from "../../../functions/planDetails";
import PPODoubleDeepInfoBenefit from "./PPODoubleDeepInfoBenefit.component";
import { useZipRootLoaderData } from "../../../hooks/useZipRootLoaderData";

const PPODataTableDetailDoctors = ({ data }: { data: IFullPlanDetailPPO }) => {
  const { selectedYear } = useZipRootLoaderData();

  const inpatientHospitalBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(data, "Inpatient Hospital-Acute")
      : getDoubleDataPPO(data, "Inpatient Hospital Acute");
  const outpatientHospitalBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(
          data,
          "Outpatient Hospital Services and Observation Services"
        )
      : getDoubleDataPPO(data, "Outpatient hospital services");
  const ambulatoryBenefit = getDoubleDataPPO(
    data,
    "Ambulatory Surgical Center (ASC) Services"
  );
  const preventiceCareBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(
          data,
          "Medicare-covered Zero Dollar Preventive Services"
        )
      : getDoubleDataPPO(
          data,
          "Medicare-Covered Zero Dollar Preventive Services"
        );
  const emergencyCareBenefit =
    selectedYear === 2024
      ? getDoubleDeepPPO(
          data,
          "Emergency Care/ Post-Stabilization Care",
          "Emergency Services"
        )
      : getDoubleDeepPPO(
          data,
          "Emergency Care/ Post-Stabilization Care",
          "Emergency Care/Post-Stabilization Care"
        );
  const urgentlyServicesBenefit = getDoubleDeepPPO(
    data,
    "Urgently Needed Services",
    "Urgently Needed Services"
  );
  const proceduresBenefit = getDoubleDataPPO(
    data,
    "Outpatient Diag Procs\\/Tests\\/Lab Services"
  );
  const xrayBenefit = getDoubleDataPPO(
    data,
    "Outpatient Diag\\/Therapeutic Rad Services"
  );
  // const diagnosctiBenefit = getDoubleDataPPO(
  //   data,
  //   "Outpatient Diag Procs\\/Tests\\/Lab Services"
  // );
  // const therapeuticBenefit = getDoubleDataPPO(
  //   data,
  //   "Outpatient Diag\\/Therapeutic Rad Services"
  // );
  const physicalspeechBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(data, "Physical and Speech Therapy Services")
      : getDoubleDataPPO(data, "Physical and Speech Therapy services");
  const groundairBenefit =
    selectedYear === 2024
      ? getDoubleDataPPO(
          data,
          "Ambulance Services (Ground and Air Ambulance Services)"
        )
      : getDoubleDataPPO(data, "Ground and Air Ambulance Services");
  const nursingBenefit = getDoubleDataPPO(
    data,
    "Skilled Nursing Facility (SNF)"
  );

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <div
        className="grid-x hide-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        ></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: 20,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4"></div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          In-Network
        </div>
        <div
          className="cell small-4"
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Out-of-Network
        </div>
      </div>
      <PPODoubleInfoBenefit
        benefit={inpatientHospitalBenefit}
        title="Inpatient Hospital - Acute"
      />
      <PPODoubleInfoBenefit
        benefit={outpatientHospitalBenefit}
        title="Outpatient Hospital & Observation "
      />
      <PPODoubleInfoBenefit
        benefit={ambulatoryBenefit}
        title="Ambulatory Surgical Center"
      />
      <PPODoubleInfoBenefit
        benefit={preventiceCareBenefit}
        title="Preventive Care"
      />
      <PPODoubleDeepInfoBenefit
        benefit={emergencyCareBenefit}
        title="Emergency Care"
      />
      <PPODoubleDeepInfoBenefit
        benefit={urgentlyServicesBenefit}
        title="Urgently Needed Services"
      />
      <PPODoubleInfoBenefit
        benefit={proceduresBenefit}
        title="Procedures, Tests, Lab Services"
      />
      <PPODoubleInfoBenefit
        benefit={xrayBenefit}
        title="Outpatient Radiology"
        subtitle="(X-Ray, Diagnostic, and Therapeutic Radiology Services)"
      />
      <PPODoubleInfoBenefit
        benefit={physicalspeechBenefit}
        title="Physical & Speech Therapy"
      />
      <PPODoubleInfoBenefit
        benefit={groundairBenefit}
        title="Ground & Air Ambulance"
      />
      <PPODoubleInfoBenefit
        benefit={nursingBenefit}
        title="Skilled Nursing Facility"
      />
    </div>
  );
};

export default PPODataTableDetailDoctors;
